export default __webpack_public_path__ + "static/media/pic1.079b54e1.jpg";